<template>
  <div>
    <numero-radicacion
      :radicacionModal="radicacionModal"
      @goToList="goToList"
      @clear-process-id="process = null"
    />
    <procesos-list v-if="!process" ref="list" @go-to-details="goToDetails" />
    <process-details
      :process="process"
      ref="details"
      v-if="process"
      @clear-process-id="process = null"
    />
  </div>
</template>
<script>
import NumeroRadicacion from '@/components/process/NumeroRadicacion';
import ProcesosList from '@/components/process/ProcesosList';
import ProcessDetails from '@/views/process/ProcessDetails';

export default {
  data() {
    return {
      process: null,
    };
  },
  props: ['radicacionModal'],
  components: {
    NumeroRadicacion,
    ProcesosList,
    ProcessDetails,
  },
  methods: {
    goToList() {
      this.process = null;
      // Hacer scroll hasta la posición referenciada
      this.$vuetify.goTo(this.$refs.list);
    },
    goToDetails(process) {
      this.process = process;
    },
  },
  created() {
    this.$store.dispatch(
      'process/setUrlAyuda',
      'manual/consulta.html#consulta-por-numero-de-radicacion'
    );
  },
};
</script>
